/*
Documentation

This file renders the site home page

*/

import { architeckCall } from 'database';
import keys from 'keys';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

class Home extends React.Component {

    state = {
        posts: [],
        main_post: {}
    }

    componentWillMount = async  () => {

        if(this.props.app_articles && this.props.app_articles.length) {

            this.setState({posts: this.props.app_articles})

        } else {

            const posts = await architeckCall({
                method: 'get',
                url: '/api/v1/archk_articles/list/?limit=10&find_by=post_status__published',
            })
    
            if(posts.success) {
                this.setState({posts: posts.data, loaded: true})
            } else {
                toggleAlert(true, 'warning', `Error: ${posts.message}.`, 'infinite' )
            }

        }

       
        
    }

    render() {

        const posts = this.state.posts


        if(!posts) {
            return (

                <div className="py-6 text-center">
                    <h1>No posts found.</h1>
                </div>

            )
        }

                
        return (
        <>

            <Helmet>
                <title>{keys.COMPANY}</title>
                <meta name="description" content="Home Page" />
            </Helmet>

            <div className="main-content articles">

               

                <section className="py-6 bg-white">

                 
                    <Container>
                        <Row>
                            <Col lg={4}>
                                <Link to="/categories/Business">
                                    <Card className="text-center">
                                        <CardHeader>
                                            <p className="mb-0">Category</p>
                                        </CardHeader>
                                        <CardBody>
                                            <h2 className="display-1"><i className="fas fa-user-tie text-success"></i></h2>
                                            <h2>Business</h2>
                                        </CardBody>
                                    </Card>
                                </Link>
                            </Col>

                            <Col lg={4}>
                                <Link to="/categories/Marketing">
                                    <Card className="text-center">
                                        <CardHeader>
                                            <p className="mb-0">Category</p>
                                        </CardHeader>
                                        <CardBody>
                                            <h2 className="display-1"><i className="fas fa-dollar-sign text-success"></i></h2>
                                            <h2>Marketing</h2>
                                        </CardBody>
                                    </Card>
                                </Link>
                            </Col>

                            <Col lg={4}>
                                <Link to="/categories/Architecture">
                                    <Card className="text-center">
                                        <CardHeader>
                                            <p className="mb-0">Category</p>
                                        </CardHeader>
                                        <CardBody>
                                            <h2 className="display-1"><i className="fas fa-code-branch text-success"></i></h2>
                                            <h2>Architecture</h2>
                                        </CardBody>
                                    </Card>
                                </Link>
                           </Col>

                           <Col lg={4}></Col>

                            <Col lg={4}>
                                    <Link to="/categories/Developers">
                                        <Card className="text-center">
                                            <CardHeader>
                                                <p className="mb-0">Category</p>
                                            </CardHeader>
                                            <CardBody>
                                                <h2 className="display-1"><i className="fas fa-code text-success"></i></h2>
                                                <h2>Developers</h2>
                                            </CardBody>
                                        </Card>
                                    </Link>
                            </Col>

                           <Col lg={4}></Col>

                        </Row>
                    </Container>
                </section>

                <section className="py-6">
                    <Container>
                        <Row>
                            <Col md={3} className="align-self-center">
                                <span style={{display: 'inline-block'}} className="mr-3">
                                    <img style={{width: 50, borderRadius: 50, marginTop: -20}} src="https://res.cloudinary.com/architeck/image/upload/v1572820069/RealEstate/2019-11-03T22:27:49.853Z.jpg" alt="" />
                                </span>
                                <span style={{display: 'inline-block', paddingTop: 0}}>
                                    <span className="">
                                        Founder <br /> 
                                        <b >John Maher</b>
                                    </span>
                                </span>
                            </Col>
                            <Col md={9}>
                                <p>There is nothing I have more passion for then helping businesses and entrepreneurs create the systems that change lives. Both for themselves, their families, and the people that depend on them. That's what drives me every day to deliver the best products and services out there, day in and day out.</p>
                            </Col>
                        </Row>
                    </Container>
                </section>


            </div>

        </>
        );
    }
}


  
const mapStateToProps = state => {

    return {
  
      app_articles: state.articles.app_articles,
  
    };
};
  
export default connect(mapStateToProps, '')(Home);